<template>
  <div class="fondo_transparente">
    <div class="ventana_modal">
      <XCerrarModal @click="cerrar" id="XCerrar"/>
      <div class="cabecera">
        <p>Restaurar contraseña</p>
        <h4 v-show="mostrarAviso" :style="{color: colorAviso}">{{aviso}}</h4>
      </div>
      <!-- <div class="entradas"> -->
      <input
        v-show="inputMail"
        type="email"
        ref="email"
        name="correo"
        v-model="mailRest"
        class="entrada"
        placeholder="E-MAIL"
        @click="mostrarAviso = false"
        @blur="primeraValidacion(mailRest)"
        required
      >
      <input
        v-show="inputCodeRec"
        type="text"
        ref="code"
        name="recCode"
        v-model="recCode"
        class="entrada"
        placeholder="Código de restauración"
        @click="mostrarAviso = false"
        required
        autocomplete="off"
      >
      <input :type="modoPass" name="newPass" class="entrada"
        v-show="inputNewPass"
        ref="pass1"
        placeholder="Nueva contraseña"
        @blur="checkPass (newPass1)"
        v-model.trim="newPass1"
        spellcheck="false"
        autocomplete="off">
      <p class="ojo"  @click="verPass" v-show="inputNewPass">&gtcc;</p>
      <input type="password" name="newPass2" class="entrada"
        v-show="inputNewPass"
        ref="pass2"
        placeholder="Reescribir contraseña"
        v-model.trim="newPass2"
        :disabled = !habilitaNewPass
        spellcheck="false"
        autocomplete="off"
      >
        <!-- @blur="validarEmail (mailRest)" -->
      <!-- </div> -->
      <div class="pieLogin">
        <div class="pieAux">{{msgFooter}}</div>
        <button
          type="button"
          class="entrar"
          @click="olvidoPass"
          :disabled= !formatoValido
        ><p>ENVIAR</p></button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import XCerrarModal from './XCerrarModal.vue'
export default {
  components: { XCerrarModal },
  name: 'olvidoPass',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.msgFooter = this.msgEmail
  },
  data () {
    return {
      mailRest: '',
      mostrarAviso: false,
      aviso: '',
      mailValido: false,
      colorAviso: 'red',
      msgEmail: 'Se enviará un e-mail a esta dirección para restaurar el password',
      msgCode: 'Introduce el código enviado a tu e-Mail para restaurar la contraseña',
      inputMail: true,
      inputCodeRec: false,
      inputNewPass: false,
      modoPass: 'password',
      habilitaNewPass: false,
      newPass1: '',
      newPass2: '',
      recCode: '',
      pinLS: '',
      URLbase: ''
    }
  },
  methods: {
    cerrar () {
      this.$router.push('/')
    },
    primeraValidacion (mail) {
      if (!this.mailRest) {
        this.mostrarAviso = true
        this.aviso = 'Es necesario escribir la dirección de e-mail'
      } else if (!this.formatoCorrecto(mail)) {
        this.mostrarAviso = true
        this.aviso = 'El formato de la dirección no es válido'
      }
    },
    olvidoPass () {
      if (this.inputMail) { this.olvidoPassMail() }
      if (this.inputCodeRec) { this.olvidoPassCode() }
      if (this.inputNewPass) { this.newPass() }
    },
    olvidoPassMail () {
      const url = `${this.URLbase}/users/veriMail`
      axios.post(url, { email: this.mailRest })
        .then(result => {
          if (result.data === 'yaRegistrado') {
            // console.log('Validado para enviar mail ')
            const url = `${this.URLbase}/send-mail`
            axios.post(url, { email: this.mailRest, caso: 'recPass' })
              .then(result => {
                if (result.data === 'success') {
                  this.colorAviso = 'greenyellow'
                  this.mostrarAviso = true
                  this.aviso = 'Se ha enviado un e-mail, revisa tu correo'
                  setTimeout(() => { this.getCode() }, 3000)
                } else {
                  this.alertJoa('Error al enviar el mail', 'E')
                  this.$router.push('/')
                }
              })
              .catch(error => console.log(error))
          } else {
            this.mostrarAviso = true
            this.aviso = 'La dirección de e-mail no está registrada'
            this.mailValido = false
          }
        })
        .catch(error => {
          console.log(error)
          // alert('No se pudo verificar el e-mail')
        })
    },
    olvidoPassCode () {
      if (this.recCode.length < 6 || this.recCode.length > 6) {
        this.mostrarAviso = true
        this.colorAviso = 'red'
        this.aviso = 'El código no es correcto, verifícalo'
      } else {
        const url = `${this.URLbase}/veri-pin`
        axios.post(url, { pin: this.recCode, mail: this.mailRest })
          .then(result => {
            if (result.data === 'success') {
              this.alertJoa('¡Código de restauración correcto!', 'S')
              this.inputCodeRec = false
              this.inputNewPass = true
              this.msgFooter = ''
              localStorage.setItem(this.pinLS, this.recCode)
              // Se guarda el pin en Local Storage para reenviarlo
              // con el nuevo pass y validarlo nuevamente en el servidor
            } else {
              this.alertJoa('Código de restauración incorrecto', 'E')
              this.$router.push('/') // Se ejecuta esta ruta antes de cerrar el alert
            }
          })
          .catch(error => console.log(error))
      }
    },
    newPass () {
      if (this.newPass1 === this.newPass2) {
        try {
          const url = `${this.URLbase}/users/newPass`
          const PIN = localStorage.getItem(this.pinLS)
          const datReg = ({ mail: this.mailRest, pass: this.newPass1, PIN: PIN })
          axios.post(url, datReg)
            .then(result => {
              switch (result.data) {
                case 'fail':
                  this.alertJoa('Error en la restauración, reinicia la aplicación e intenta otra vez', 'E')
                  break
                case 'success':
                  this.alertJoa('Contraseña cambiada con éxito. En el próximo ingreso, usa la nueva contraseña.', 'S')
                  break
                case 'failPIN':
                  this.alertJoa('Error de seguridad, reinicia la aplicación e intenta otra vez', 'E')
                  break
              }
              localStorage.removeItem(this.pinLS)
              this.$router.push('/')
            })
            .catch(error => console.log(error))
        } catch (error) {
          console.log(error)
        }
      } else {
        this.alertJoa('Las contraseñas no son iguales', 'W')
      }
    },
    getCode () {
      this.inputMail = false
      this.inputCodeRec = true
      this.mostrarAviso = false
      this.msgFooter = this.msgCode
    },
    verPass () {
      this.modoPass = 'text'
      setTimeout(() => { this.modoPass = 'password' }, 2500)
    },
    checkPass (password) {
      if (this.checkPassword(password)) {
        this.habilitaNewPass = true
        this.$refs.pass2.focus()
      } else {
        this.alertJoa('La contraseña debe contener (como mínimo) un número, una minúscula, una mayúscula y seis caracteres', 'W')
        this.$refs.pass1.focus()
      }
    },
    checkPassword (pass) {
      // mínimo un número, una minúscula y una mayúscula
      // mínimo seis caracteres
      var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
      return re.test(pass)
    },
    formatoCorrecto (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
  computed: {
    formatoValido () {
      return this.formatoCorrecto(this.mailRest)
    }
  }

}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.ventana_modal{
  width: 450px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  /* grid-template-rows: 35% 15% 25%; */
  justify-items: center;
  align-items: space-around;
}
.cabecera{
  background-color: rgba(10, 90, 140, 0.5);
  justify-self: stretch;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  /* border: solid 1px rgb(130, 238, 130); */
  display:grid;
  /*grid-template-rows: 70% 30%; */
  height: 35%;
}
.cabecera h4 {
  position: absolute;
  font-weight: 600;
  color: rgb(255, 102, 102);
  left: 8%;
  top: 75px;
}
.cabecera p{
  justify-self: left;
  align-self: center;
  margin-left: 8%;
  font-size: 35px;
  font-weight: lighter;
  padding-bottom: 4px;
  color:var(--na);
}
.entrada{
  /* border: solid 1px rgb(130, 238, 130); */
  margin: 0px;
  padding-left: 8%;
  font-size: 18px;
  background-color: rgb(250, 248, 242);
  outline:none;
  border:none;
  border-bottom: solid 1px rgba(10, 90, 140, 0.5);
  height: 15%;
}
.entrada:focus{
  outline:none
}
.ojo{
  position: absolute;
  color:rgba(10, 90, 140, 0.5);
  font-size: 20px;
  top: 32%;
  right: 20px;
}
.ojo:hover{
  cursor: pointer;
}
.pieLogin{
  display:grid;
  /* border: solid 1px rgb(130, 238, 130); */
  grid-template-columns: 60% 40%;
  justify-self: stretch;
  background-color: rgba(10, 90, 140, 0.5);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  font-weight:300;
  padding-left: 3%;
  height: 25%;
}
.pieAux{
  display:flex;
  flex-direction: column;
  /* grid-template-rows: 50% 50%; */
  /* align-items: center; */
  justify-content: space-evenly;
  text-shadow: 1px 1px black;
}
.entrar{
  align-self: center;
  font-size: 20px;
  font-weight: lighter;
  width: 80%;
  border-radius:55px;
  padding: 4% 5% 5% 5%;
  color:var(--na);
  background-color: transparent;
  border: solid 1px rgba(1, 117, 163, 0);
  cursor: pointer;
}
.entrar p {
  margin:auto;
  -moz-transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.entrar:disabled {
  color:lightslategrey;
}
.entrar:hover:enabled{
  /* background-color: rgba(1, 117, 163, 0.4); */
  border: solid 1px rgba(10, 90, 140, 0.7);
}
.entrar:hover:enabled p{
  transform: translateY(-5px);
}
@media screen and (max-width: 576px){
  .ventana_modal{
    width: 90%;
  }
  .cabecera p{
    margin-left: 7%;
    font-size: 30px;
    font-weight: 300;
    padding-bottom: 0px;
    padding-top: 2px;
  }
  .pieAux{
    font-size: 15px;
  }
}
</style>
